﻿import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import definitions from '../Style/LfStyleDefinitions';

export default class ErrorMessage extends React.Component {
    constructor(props) {
        super(props);
    }

    static get propTypes() {
        return {
            message: PropTypes.string
        }
    }

    render() {
        return (
            <ErrorWrapper>
                <strong>{this.props.message}</strong>
                {this.props.children}
            </ErrorWrapper>
        );
    }        
}

const ErrorWrapper = styled.div`
    position: relative;
    width: 100%; 
    min-height: 100px;

    margin-top: 15px; 

    text-align: center;

    strong {
        color: red;
        font-family: ${definitions.fonts.heading};
    }
`;
